import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/logo_massons_traffic-icon.svg'
import _imports_1 from '@/assets/icons/logo-dashboard-icon.svg'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  style: {"width":"250px"}
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  style: {"width":"250px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mb)
    ? (_openBlock(), _createElementBlock("img", _hoisted_1))
    : (_openBlock(), _createElementBlock("img", _hoisted_2))
}